import React, {useState, useEffect} from 'react';
//import Container from 'react-bootstrap/Container';
import {Spinner} from '../Spinner/Spinner';
import { FaClipboard} from 'react-icons/fa';
import {runQuery, goToGitHubEdit, copyToClipboard} from '../utils'
//import {runQuery, copyToClipboard} from '@jeffreycwitt/lbp2.utils';
import {getManifestationCitationInfo} from './query'



// function copyToClipboard(text: string){
//   var dummy = document.createElement("textarea");
//   document.body.appendChild(dummy);
//   dummy.value = text;
//   dummy.select();
//   document.execCommand("copy");
//   document.body.removeChild(dummy);
// }

// function runQuery(query){
//   const sparqlEndpoint = "https://sparql.scta.info/ds/query"
//   const queryPromise = Axios.get(sparqlEndpoint, { params: { "query": query, "output": "json" } })
//   return queryPromise
// }



/**
* citation component
*
* TODO: it would be better to separate the citation display, manifestation picker, citation explation
* into three differen compoments wrapped in a citation Wrapper.
* This way the citation display could be truly independent
*/


/**
 * 
 * citationStyle: full (default) minimal
 * showGitHubEdit: true false
 * 
 */

export interface MyComponentProps {
  // Define your prop types here
  tresourceid: string,
  citationStyle?: string,
  showGitHubEdit?: boolean,
  selectionRange?: any,
  handleChangeInfo?: any // a parent function allow a focus change when a resource is selected
}


export const Citation: React.FC<MyComponentProps> = (props) => {
// const Citation = (props) => {
  const [citInfo, setCitInfo] = useState<any>({})
  const [fetching, setFetching] = useState<boolean>(false)
  
  useEffect(() => {
    setFetching(true)
    retrieveCitation(props.tresourceid)
  }, [props.tresourceid])
  
  useEffect(() => {
    setFetching(false)
  }, [citInfo])

  const retrieveCitation = (tresourceid: string) => {
    if (tresourceid){
      // this.setState({fetching: true})
      const manifestationCitationInfo = runQuery(getManifestationCitationInfo(tresourceid))
      manifestationCitationInfo.then((data) => {
        const allBindings = data.data.results.bindings
        if (allBindings.length > 0){
          const bindings = allBindings[0]
          const expressionid = bindings.expression ? bindings.expression.value : ""
          const manifestationid = bindings.manifestation ? bindings.manifestation.value : ""
          const eLongTitle = bindings.eLongTitle ? bindings.eLongTitle.value : ""
          const authorTitle = bindings.authorTitle ? bindings.authorTitle.value : ""
          const author = bindings.author ? bindings.author.value : ""
          const editorTitle = bindings.editorTitle ? bindings.editorTitle.value : ""
          const editor = bindings.editor ? bindings.editor.value : ""
          const datasource = bindings.datasource ? bindings.datasource.value : ""
          const docsource = bindings?.docsource?.value
          const structureType = bindings?.structureType?.value
          const title = bindings.codexTitle ? bindings.codexTitle.value : ""
          const start = bindings.surfaceTitle ? bindings.surfaceTitle.value : ""
          const end = allBindings[allBindings.length - 1].surfaceTitle ? allBindings[allBindings.length - 1].surfaceTitle.value : ""
          //if (this.mounted){
          
          const citInfo = {
                author: author,
                authorTitle: authorTitle,
                editor: editor,
                editorTitle: editorTitle,
                eurl: expressionid,
                etitle: eLongTitle,
                murl: manifestationid,
                mtitle: start !== end ? title + ", " + start + "-" + end : title + ", " + start,
                turl: tresourceid,
                datasource: datasource,
                docsource: docsource,
                structureType: structureType

              }
            
            setCitInfo(citInfo)
          }
      
        })
    }
  }
  

  const showGitHubEdit = () => {
    if (citInfo.structureType === "http://scta.info/resource/structureItem" 
      || citInfo.structureType === "http://scta.info/resource/structureBlock" 
      || citInfo.structureType === "http://scta.info/resource/structureElement") {

      return (
      <span onClick={() => {goToGitHubEdit(citInfo.docsource.split("#")[0], props?.selectionRange?.text?.split(" ")[0] || "", citInfo.eurl.split("/resource/")[1])}}>Edit on Github</span>
    ) 
  }
}
  
  const fullCitationString = citInfo.authorTitle + ", " + citInfo.etitle + "(" + citInfo.mtitle + ") Data source: " + citInfo.datasource + "."
    const wordRange = props.selectionRange && props.selectionRange.wordRange && 
      props.selectionRange.wordRange.start + "-" + props.selectionRange.wordRange.end;
    return (
      <>
        {props.citationStyle === "minimal" ? 
        <div>
        <p className="etitle">
          
          {props.handleChangeInfo ? <span className="lbp-span-link" onClick={() => {props.handleChangeInfo(props.tresourceid)}}>{citInfo.authorTitle}, {citInfo.etitle} {wordRange && wordRange && "@ " + wordRange} </span> 
          : 
          <span>{citInfo.authorTitle}, {citInfo.etitle} {wordRange && wordRange && "@ " + wordRange}</span>
          }
        <span className="lbp-span-link" title="Copy SCTA ID to Clipboard" onClick={(e) => {e.preventDefault(); copyToClipboard(wordRange ? citInfo.turl + "@" + wordRange : citInfo.turl)}}><FaClipboard /></span>
        <br/>
          {props.showGitHubEdit && <span> ({showGitHubEdit()})</span>}</p>
        </div>
        :
        <div>
      <h4>Citation</h4>
      {fetching ?
        <Spinner/> 
        // <p>fetching</p>
        :
      <div>
        <p className="etitle">{citInfo.authorTitle}, {citInfo.etitle} {wordRange && wordRange && "@ " + wordRange} (<a href={citInfo.eurl} target="_blank" rel="noopener noreferrer">{citInfo.eurl}{wordRange && "@" + wordRange}</a> <span className="lbp-span-link" title="Copy Citation to Clipboard" onClick={(e) => {e.preventDefault(); copyToClipboard(wordRange ? citInfo.eurl + "@" + wordRange : citInfo.eurl)}}><FaClipboard /></span>)</p>

        <p className="mtitle">
          {citInfo.editor && <span>Ed. {citInfo.editorTitle}, </span>}
          
          {citInfo.mtitle && citInfo.mtitle + " "}
          
          (<a href={citInfo.murl} target="_blank" rel="noopener noreferrer">{citInfo.murl}{wordRange && "@" + wordRange}</a> 
          
          <span className="lbp-span-link" title="Copy Citation to Clipboard" onClick={(e) => {e.preventDefault(); copyToClipboard(wordRange ? citInfo.murl + "@" + wordRange : citInfo.murl)}}><FaClipboard /></span>)
        </p>

        <p className="ttitle">
          <span>Transcription Resource: </span>
          <a href={citInfo.turl} target="_blank" rel="noopener noreferrer">{citInfo.turl}{wordRange && "@" + wordRange}</a>
          <span className="lbp-span-link" title="Copy Citation to Clipboard" onClick={(e) => {e.preventDefault(); copyToClipboard(wordRange ? citInfo.turl + "@" + wordRange : citInfo.turl)}}><FaClipboard /></span>
          <br/>
          <span>Data source: </span>
          <a href={citInfo.datasource} target="_blank" rel="noopener noreferrer"> {citInfo.datasource}</a> 
          <span className="lbp-span-link" title="Copy Citation to Clipboard" onClick={(e) => {e.preventDefault(); copyToClipboard(citInfo.datasource)}}><FaClipboard /></span>
          </p>
        <p className="lbp-span-link" title="Copy Citation to Clipboard" onClick={(e) => {e.preventDefault(); copyToClipboard(fullCitationString)}}> <FaClipboard /> Copy Full Citation to Clipboard</p>
        
        {props.showGitHubEdit && showGitHubEdit()}
      </div>
      }
      </div>
    }
      </>
    );
}

// Citation.defaultProps = {
//   tresourceid: "http://scta.info/resource/lectio1/critical/transcription",
// };

// Citation.propTypes = {
//   /**
//   * transcription resource id of focused passage,
//   * transcription id is required, because a specific text passage is being complicated
//   *
//   * TODO: perhaps it would be good to allow the expression or manifestation id to be given
//   * but the citation component would need to know what kind of resource this and would
//   * need to produce a different query in each case
//   */
//   tresourceid: PropTypes.string.isRequired,

// }

// export {Citation};
